import React from "react";
import PropTypes from "prop-types";

export const FeedCardHeaderIcon = ({ children, className = "" }) => (
  <div className={`media__img ${className}`}>{children}</div>
);

FeedCardHeaderIcon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default FeedCardHeaderIcon;
